var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"disabled":_vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('loading-spinner',{staticClass:"loading-spinner--white"}):_vm._t("default",[_vm._v("Submit")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }